export default __webpack_public_path__ + "static/media/348x348.c8ac24a9.png";